import PerfilClienteEndereco from './perfil-cliente-endereco.model';

export default class PerfilCliente {
  nome: string;
  email?: string;
  celular?: string;
  telefone: string;
  endereco: PerfilClienteEndereco;

  constructor() {
    this.endereco = new PerfilClienteEndereco();
  }
}
